import { createFileRoute } from '@tanstack/react-router'

import PhongNhaCheckoutPage from '@/layouts/themes/phong-nha/pages/checkout'

export const Route = createFileRoute('/phong-nha/checkout')({
  component: PhongNhaCheckoutPage,
})
